// extracted by mini-css-extract-plugin
module.exports = {"simpleList":"simpleList___McOVT","simpleListOption":"simpleListOption___2bQyA","active":"active___2kT6y"};